import { useState } from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import Text from '../../../../Text';
import i18n from '../../../../../app/i18n';
import defaultAttrs from '../../../../../lib/utils/defaultAttrs';

const TileText = ({ tileText, onChangeTileText }) => {
  const [isEditingTileText, setIsEditingTileText] = useState(false);

  const handleSelect = ({ target }) => {
    target.select();
  };

  return isEditingTileText ? (
    <TitleTextEdit
      name="question"
      as="textarea"
      variant="h5"
      cols="40"
      rows="2"
      placeholder={i18n.t('tileForm:interaction.placeholders.tileText')}
      value={tileText}
      onChange={onChangeTileText}
      onBlur={() => setIsEditingTileText(false)}
      autoFocus
      onFocus={handleSelect}
    ></TitleTextEdit>
  ) : (
    <TileTextDisplay
      as="div"
      variant="h5"
      onClick={() => setIsEditingTileText(true)}
    >
      {tileText}
      <TitleTextIcon />
    </TileTextDisplay>
  );
};

export default TileText;

const TileTextDisplay = styled(Text)`
  display: flex;
  padding: 14px 0;
  margin: 10px 0px 6px;
  cursor: pointer;
  width: 100%;
`;

const TitleTextIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-regular fa-pencil',
  }),
)`
  width: 17px;
  height: 17px;
  border: 0;
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  margin-left: 19px;
  color: ${themeGet('colors.primary.100')};
`;

const TitleTextEdit = styled(Text)`
  background: inherit;
  border-color: transparent;
  height: 64px;
  padding: 14px 0 0;
  margin-top: 10px;
  margin-bottom: 6px;
  overflow-x: hidden;
  overflow-wrap: break-word;
`;
